<h3
  *ngIf="!isTablet && !isGroupsetQuery"
  [innerHtml]="'customSearch.title' | cxTranslate : { count: count, query: searchBoxQuery }"
></h3>
<h3
  *ngIf="!isTablet && isGroupsetQuery"
  [innerHtml]="'customSearch.titleForGroupset' | cxTranslate : { count: count }"
></h3>
<h3
  *ngIf="isTablet && !isGroupsetQuery"
  [innerHtml]="'customSearch.tabletTitle' | cxTranslate : { count: count, query: searchBoxQuery }"
></h3>
<h3
  *ngIf="isTablet && isGroupsetQuery"
  [innerHtml]="'customSearch.tabletTitleForGroupset' | cxTranslate : { count: count }"
></h3>
<span
  *ngIf="isTablet && (isCustomTranslationsEnabled$ | async) !== null"
  [innerHtml]="
    'customSearch.tabletCount'
      | cxTranslate
        : {
            count: count,
            context: setCustomContext(
              isCustomTranslationsEnabled$ | async,
              activeCountry$ | async,
              activeLanguage$ | async
            )
          }
  "
></span>
